export const getPlayerName = (name: string) => {
  if (!name) return '-';
  const [lastName, firstName] = name.split(',').map(v => v.trim());
  if (!firstName) return lastName;
  return `${firstName} ${lastName}`;
};
